import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { CONSTANTS } from '../../../environments/environment';
import { TokenData } from '../token/token.service';
import { Account } from '../wallet/wallet';

interface PrepareTokenTransfer {
  account: Account;
  tokenTransfer: string;
  symbol: string;
}
interface MetadataUpdated {
  contractAddress: string;
  id: number;
  token: TokenData;
}
@Injectable({
  providedIn: 'root'
})

export class SubjectService {
  public metadataUpdated: BehaviorSubject<MetadataUpdated>;
  public markets: BehaviorSubject<any>;
  public confirmedOp: Subject<string>;
  public prepareTokenTransfer: Subject<PrepareTokenTransfer>;
  public nftsUpdated: BehaviorSubject<any>;
  public origin: BehaviorSubject<string>;
  public beaconResponse: Subject<boolean>;
  public logout: Subject<boolean>;
  public rpc: BehaviorSubject<string>;
  constructor() {
    this.init();
    this.logout.subscribe(o => {
      if (o) {
        this.reset();
      }
    })
  }
  init() {

    const settings = localStorage.getItem('settings');
    const rpc = settings ? JSON.parse(settings)?.global?.rpc.current ?? CONSTANTS.NODE_URL : CONSTANTS.NODE_URL;

    this.metadataUpdated = new BehaviorSubject<MetadataUpdated>(null);
    this.markets = new BehaviorSubject<any>([]);
    this.confirmedOp = new Subject<string>();
    this.prepareTokenTransfer = new Subject<PrepareTokenTransfer>();
    this.nftsUpdated = new BehaviorSubject<any>(undefined);
    this.origin = new BehaviorSubject<string>(null);
    this.beaconResponse = new Subject<boolean>();
    this.logout = new Subject<boolean>();
    this.rpc = new BehaviorSubject<string>(rpc);
  }
  reset() {
    this.metadataUpdated.next(null);
    this.markets.next([]);
    this.nftsUpdated.next(undefined);
  }
}
